import { createRouter, createWebHistory } from "vue-router";

export const constantRoutes = [
  {
    path: "/weLogin",
    component: () => import("../views/login/weLogin.vue"),
    meta: { title: '登录' }
  },
  {
    path: "/booking",
    component: () => import("../views/booking/punterBooking.vue"),
    meta: { title: '预约' }
  },
  {
    path: "/task",
    component: () => import("../views/task/index.vue"),
    meta: { title: '任务列表' }
  },
  {
    path: "/task/create",
    component: () => import("../views/task/form.vue"),
    meta: { title: '新建任务' }
  },
  {
    path: "/task/:id/edit",
    component: () => import("../views/task/form.vue"),
    meta: { title: '编辑任务' }
  },
  {
    path: "/task/:id",
    component: () => import("../views/task/detail.vue"),
    meta: { title: '任务详情' }
  },
  {
    path: "/upload",
    component: () => import("../views/ImageUpload/image.vue"),
    meta: { title: '图片上传' }
  },
  {
    path: '/toDoor',
    component: () => import("@/views/subscribe/toDoor/index"),
    meta: { title: '上门统计' }
  },
  {
    path: '/subscribe',
    component: () => import("@/views/subscribe/index"),
    meta: { title: '预约' }
  },
   {
    path: '/bookShifts',
    component: () => import("@/views/booking/bookShifts.vue"),
    meta: { title: '预约查看' }
  },
  {
    path: '/smsFollowUp',
    component: () => import("@/views/smsFollowUp/index"),
    meta: { title: '调查问卷' }
  },
]
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});
// router.beforeEach((to, from, next) => {
//   document.title = to.meta.title || '预约'; // 使用路由的meta.title或者一个默认标题
//   next();
// });

export default router;
